import React, {useState} from 'react'; // , {useEffect}
// import {useNavigate} from "react-router-dom";
// import {getMessaging, getToken} from "firebase/messaging";

import {checkActionCode} from "firebase/auth";

import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';

import TextField from '@mui/material/TextField';

import {getAuth} from "firebase/auth";

import {LOG_TYPES, HISTORY_USER} from "ultra/const/log";
import {getClientUrl} from 'ultra/configs/general';
import {DEFAULT_CITY} from 'ultra/const/general';

import PersonAddAltOutlinedIcon from '@mui/icons-material/PersonAddAltOutlined';
import PasswordOutlinedIcon from '@mui/icons-material/PasswordOutlined';

import {useNavigationStore} from '../../../../Stores/navigation';
import {useToasterStore} from '../../../../Stores/toster';
import {useBackdropPreloaderStore} from '../../../../Stores/backdropPreloader';

import {USER_ACTIONS} from '../../../Profile/Reducers/user';

import {signIn} from "../../Helpers/user"; // saveSubToken
import {useGlobalCustomContext} from '../../../../Helpers/context';
import {error} from '../../../../Helpers/logs';
// import {setPageTitle} from '../../../../Helpers/router';

import {emailValidated, saveUserHistoryAndNotify} from '../../../../Modules/Profile/Helpers/user'

import SignUp from '../SignUp';
import Reset from '../Reset'

import ButtonWithPreloader from '../../../../Components/Form/ButtonWithPreloader';
import AdaptiveDialog from '../../../../Components/Adaptive/Dialog';

import './index.scss'

export default (props) => {
    const {onSuccess, mode} = props;

    const [data, setState] = React.useState({
        email: '',
        password: '',
    });

    const [openReset, setOpenReset] = useState(false);
    const [inProgress, setInProgress] = React.useState(false);

    const {email, password} = data;

    const {hideBackdropPreloader} = useBackdropPreloaderStore();
    const {startLoading, stopLoading} = useNavigationStore();
    const {showSuccess, showError} = useToasterStore();

    const {userState, userDispatch} = useGlobalCustomContext();

    const onResetClick = () => {
        setOpenReset(true);
    }

    const handleResetClose = () => {
        setOpenReset(false);
    };

    const onResetSuccess = () => {
        setOpenReset(false);
    }

    const handleRegistrationClose = () => {
        userDispatch({type: USER_ACTIONS.REGISTRAION_CLOSE});
    };

    const onRegisterClick = () => {
        userDispatch({type: USER_ACTIONS.REGISTRAION})
    }

    const verifyEmailErrorHandler = async (action, err, oobCode, email) => {
        hideBackdropPreloader()
        setInProgress(false)

        let snackbarMessage = err.message || 'Виникла помилка, спробуйте пізніше'

        if (err.code === 'auth/invalid-action-code') {
            snackbarMessage = 'Посилання для перевірки email не валідне'
        }

        if (err.code === 'auth/expired-action-code') {
            snackbarMessage = 'Посилання для перевірки email застаріло'
        }

        const url = new URL(window.location.href);
        const continueUrl = url.searchParams.get('continueUrl');

        showError({
            snackbarMessage,
            snackbarDuration: 10000,
            onCloseRedirect: continueUrl || getClientUrl(DEFAULT_CITY, '/'),
        });

        const details = {error: err, oobCode};

        // if no email => no record for user
        if (email) {
            await saveUserHistoryAndNotify(email, LOG_TYPES.ERROR, action, details);
        } else {
            await error(LOG_TYPES.ERROR, action, details);
        }
    }

    const signInWithEmail = () => {
        if (!email || !password) {
            showError({snackbarMessage: 'Вкажіть ваш email та пароль'});
            return;
        }

        if (inProgress) {
            return;
        }

        startLoading();
        setInProgress(true);

        const url = new URL(window.location.href);
        const code = url.searchParams.get('oobCode');
        const continueUrl = url.searchParams.get('continueUrl');

        userDispatch({type: USER_ACTIONS.USER_LOGIN_IN_PROGRESS})
        signIn(email, password)
            .then(user => {
                setState({email: '', password: ''});

                stopLoading();
                onSuccess();

                const auth = getAuth();

                if (mode === 'verifyEmail') {
                    checkActionCode(auth, code)
                        .then((info) => {
                            const restoredEmail = info['data']['email'];

                            // ADD ANIMATION TO LOGIN AVATAR
                            emailValidated(restoredEmail)
                                .then(async u => {
                                    setInProgress(false)
                                    await saveUserHistoryAndNotify(restoredEmail, LOG_TYPES.INFO, HISTORY_USER.EMAIL_VALIDATION_SUCCESS);

                                    if (user.telegram_id) {
                                        userDispatch({
                                            type: USER_ACTIONS.LOGIN_TELEGRAM_LINK_OPEN,
                                            data: {
                                                email: user.email
                                            }
                                        })
                                    }
                                    else {
                                        userDispatch({type: USER_ACTIONS.USER_REFRESH_START});

                                        showSuccess({
                                            snackbarMessage: 'Email успішно підтвердженою',
                                            onCloseRedirect: continueUrl || getClientUrl(DEFAULT_CITY, '/'),
                                            snackbarDuration: 10000
                                        })
                                    }
                                })
                                .catch(async (err) => {
                                    // https://local-miy-prostir.online/?mode=verifyEmail&oobCode=7ROTvo_UQZ_tS3QhyOcpag69JJp1w2WNpyS6-arFNyAAAAGSD4D1xA&apiKey=AIzaSyC8JZNofHOXCCLItHbgkXeMgIX_j4PuVpM&lang=uk
                                    verifyEmailErrorHandler(HISTORY_USER.EMAIL_VALIDATION_ERROR, err, code, restoredEmail)
                                })
                        })
                        .catch(e => {
                            verifyEmailErrorHandler(HISTORY_USER.EMAIL_VALIDATION_CODE_ERROR, e, code)
                        })
                }
            })
            .catch((errToasterConfig) => {
                stopLoading();
                userDispatch({type: USER_ACTIONS.USER_REMOVE})

                showError({
                    ...errToasterConfig,
                    // onCloseHandler: () => {
                    //     userDispatch({type: USER_ACTIONS.LOGIN_CLOSE});
                    // }
                })

                hideBackdropPreloader()
                setInProgress(false)
            })
    }

    return (
        <div className="profileForm SignIn">
            <Grid container spacing={2} justifyContent="center" className="form">
                <Grid item xs={12} md={6}>
                    <TextField
                        disabled={inProgress}
                        fullWidth
                        variant="outlined"
                        label="Введіть ваш Email"
                        value={email}
                        onChange={(e) => setState({ ...data, email: e.target.value})}
                    />
                </Grid>

                <Grid item xs={12} md={6}>
                    <TextField
                        disabled={inProgress}
                        fullWidth
                        variant="outlined"
                        label="Введіть ваш пароль"
                        value={password}
                        type="password"
                        onChange={(e) => setState({ ...data, password: e.target.value})}
                    />
                </Grid>

                <Grid item xs={12} md={12}>
                    <ButtonWithPreloader
                        fullWidth
                        variant="contained"
                        onClick={signInWithEmail}
                        inprogress={inProgress.toString()}
                    >
                        Увійти
                    </ButtonWithPreloader>
                </Grid>

                {mode !== 'verifyEmail' && <>
                    <Grid item xs={12} md={6}>
                        <Button
                            fullWidth
                            startIcon={<PasswordOutlinedIcon />}
                            className='action login'
                            variant="outlined"
                            onClick={onResetClick}>
                                Відновити пароль
                        </Button>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Button
                            fullWidth
                            startIcon={<PersonAddAltOutlinedIcon />}
                            className='action registration'
                            variant="outlined"
                            onClick={onRegisterClick}>
                                Реєстрація
                        </Button>
                    </Grid>
                </>}

                {/* <Grid item xs={12}>
                    🇦🇺 🇮🇩 🇩🇪 🇨🇦 🇬🇧
                </Grid> */}
            </Grid>

            <AdaptiveDialog open={openReset} onClose={handleResetClose} title="Відновити пароль">
                <Reset
                    embedded
                    onClose={handleResetClose}
                    onSuccess={onResetSuccess}
                />
            </AdaptiveDialog>

            <AdaptiveDialog open={Boolean(userState?.registrationPopupOpen)} onClose={handleRegistrationClose} title="Мій Простір">
                <SignUp
                    onClose={handleRegistrationClose}
                />
            </AdaptiveDialog>
        </div>
    )
}
